import { ADD_PRODUCT_TO_CART } from '../constants/cart'

export const actionAddProductToCart = (cart) => ({
  type: ADD_PRODUCT_TO_CART,
  cart
})
